import { Component, computed, inject, input } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { KENDO_GRID } from '@progress/kendo-angular-grid';
import { AbstractGridComponent } from '@unity/abstract/abstract-grid.component';
import { AgreementUserDetailedDto, AgreementUsersClient } from '@unity/clients';
import { TypedDirective } from '@unity/directives/typed.directive';
import { GridSharedComponent } from '@unity/shared/composed/grid-shared/grid-shared.component';
import { LinkGridcellSharedComponent } from '@unity/shared/presentation/link-gridcell-shared/link-gridcell-shared.component';
import { LinkMailtoSharedComponent } from '@unity/shared/presentation/link-mailto-shared/link-mailto-shared.component';
import { QuickActions } from '@unity/utils/quick-actions';
import { SortConfig } from '@unity/utils/types';
import { ChipWorkflowStateSharedComponent } from '../presentation/chip-workflow-state-shared/chip-workflow-state-shared.component';

@Component({
  selector: 'unity-grid-agreement-user-shared',
  imports: [
    KENDO_GRID,
    GridSharedComponent,
    LinkGridcellSharedComponent,
    LinkMailtoSharedComponent,
    TypedDirective,
    ChipWorkflowStateSharedComponent,
  ],
  templateUrl: './grid-agreement-user-shared.component.html',
  styleUrl: './grid-agreement-user-shared.component.scss',
})
export class GridAgreementUserSharedComponent extends AbstractGridComponent<AgreementUserDetailedDto> {
  private readonly agreementUsersClient = inject(AgreementUsersClient);

  protected override readonly resource = rxResource({
    params: () => {
      const query = this.$gridifyQuery();
      const agreementId = this.$agreementId();
      return query && agreementId ? { query, agreementId } : undefined;
    },
    stream: ({ params: { agreementId, query } }) =>
      this.agreementUsersClient.getAllForAgreementAsDetailed(agreementId, query.page, query.pageSize, query.orderBy, query.filter),
  });

  protected readonly $assignedUsers = computed(() => {
    const users = this.resource.value();
    return users ?? [];
  });

  protected readonly manageAgreementUser = (userId: number) => {
    return QuickActions.ManageAgreementUser(this.$agreementId(), userId);
  };

  protected defaultSort: SortConfig[] = [
    {
      field: 'full_name',
      dir: 'asc',
    },
  ];

  public readonly $agreementId = input.required<number>({ alias: 'agreementId' });
}
